import { cn } from "$/lib/utils/functions/misc.functions";
import { RadioButton } from "../../atoms";
import Flexbox from "../../common/Flexbox";
import type { RadioButtonSetProps } from "./RadioButtonSet.types";

const RadioButtonSet = <T extends string | number>({
  id,
  title,
  options,
  selectedId,
  onChange,
  row = false,
  className,
}: RadioButtonSetProps<T>) => {
  return (
    <Flexbox row={row} className={cn("gap-3.5", className)}>
      <p className="whitespace-nowrap text-base font-semibold text-secondary">
        {title}
      </p>
      {options.map((option) => (
        <label htmlFor={id} className="flex items-center gap-2" key={option.id}>
          <RadioButton
            name={id}
            className="size-4"
            checked={selectedId === option.id}
            onChange={() => onChange(option.id)}
          />
          <span className="text-sm font-medium text-primary">
            {option.label}
          </span>
        </label>
      ))}
    </Flexbox>
  );
};

export default RadioButtonSet;
